import React from 'react'; //eslint-disable-line
import Cookies from 'js-cookie';
import {connect} from '../../redux/helpers/helpers';
import {logIn} from '../../redux/reducers/session/session-reducer';
import Header from '../header/header';
import {BrowserRouter, Route} from 'react-router-dom';
import {Provider} from 'react-redux';
import './app-wrapper.scss';

class SessionManager extends React.Component {
  constructor(props) {
    super(props);

    this.token = Cookies.get('sessionToken');

    if (this.token) this.props.logIn({token: this.token});
  }

  render() {
    var isLoading = this.token !== undefined && this.props.session.isLoading !== false && !this.props.session.isLoggedIn;

    return isLoading ? null : this.props.children;
  }
}

SessionManager = connect({mapDispatch: {logIn}})(SessionManager);

class AppWrapper extends React.Component {
  render() {
    var {appKey} = this.props;

    return (
      <Provider store={this.props.store}>
        <BrowserRouter>
          <SessionManager>
            <div className='sf-app-wrapper'>
              <Route render={(props) => <Header {...props} {...{appKey}}/>}/>
              <div className='sf-content'>
                {this.props.children}
              </div>
            </div>
          </SessionManager>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default AppWrapper;
